import { useEffect, useRef } from 'react';
import type { StorefrontProduct } from '../api/client';
import { viewedDetail } from '../commerce/commerceEvents';
import { trackEvent } from '../tracking/tracker';

// ViewContent, once per product page: only when the address names the product, never for the shop's first
// product standing in on a home or collection page, and only once the store's currency is known, so the
// event carries its price. Fired once even when React runs the effect twice.

// Fires ViewContent for the product a product page shows, once its currency is known.
export function useProductView(product: StorefrontProduct | null, currency: string | null): void {
  const seen = useRef<string | null>(null);
  useEffect(() => {
    if (!product?.id || !currency || seen.current === product.id) return;
    seen.current = product.id;
    trackEvent('product_view', viewedDetail(product, currency));
  }, [product, currency]);
}
